import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgAdd = (props) => {
    const { color } = props;
    return (React.createElement("path", { d: "M11 19a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6Z", fill: color }));
};
export default factorySvgIcon(SvgAdd);
//# sourceMappingURL=SvgAdd.js.map